export default __webpack_public_path__ + "static/media/26.e0d3aff4.webp";